<div class="spinner-overlay" *ngIf="!loaded">
  <mat-spinner color="primary"></mat-spinner>
</div>

<con-page-layout>
  <div class="flex-display">
    <con-page-header header="{{ 'batch_jobs.view_log_details.page_title' | translate }}"> </con-page-header>
  </div>
  <xng-breadcrumb [separator]="iconTemplate" class="breadcrumb"></xng-breadcrumb>
  <ng-template #iconTemplate>
    <mat-icon>chevron_right</mat-icon>
  </ng-template>
  <con-page-layout-content>
    <div *ngIf="loaded">
      <mat-card appearance="outlined" class="reduce-header-size">
        <mat-card-content>
          <div class="align-labels">
            <div class="info-group">
              <span class="bold-label">{{ "batch_jobs.view_log_details.log_file_name" | translate }}:</span>
              <span class="info-value">{{ logFileName }}</span>
             </div>
              <div class="info-group">
               <span class="bold-label">{{ "batch_jobs.view_log_details.execution_schedule" | translate }}:</span>
               <span class="info-value">{{ formattedTime }}</span>
              </div>
            </div>
          </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" class="margin-top">
        <mat-card-content class="multiline">
          {{ content }}
        </mat-card-content>
      </mat-card>
    </div>
  </con-page-layout-content>
</con-page-layout>
